import { render, staticRenderFns } from "./index-classify.vue?vue&type=template&id=6a1027a3&scoped=true"
import script from "./index-classify.vue?vue&type=script&lang=js"
export * from "./index-classify.vue?vue&type=script&lang=js"
import style0 from "./index-classify.vue?vue&type=style&index=0&id=6a1027a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1027a3",
  null
  
)

export default component.exports